import { render, staticRenderFns } from "./FileStatusChange.vue?vue&type=template&id=78b849af&"
import script from "./FileStatusChange.vue?vue&type=script&lang=js&"
export * from "./FileStatusChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QItem,QItemSection,QItemLabel,QBadge} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QItem,QItemSection,QItemLabel,QBadge})
